import React from 'react';
import { BMIStatus } from '../healthTypes';

interface BMIGaugeProps {
  bmi: number;
  status: BMIStatus;
  min?: number;
  max?: number;
}

export const BMIGauge: React.FC<BMIGaugeProps> = ({ bmi, status }) => {
  const minScale = 14;
  const maxScale = 32;
  const percentage = Math.min(Math.max(((bmi - minScale) / (maxScale - minScale)) * 100, 0), 100);

  return (
    <div className="w-full mt-4 mb-2">
      <div className="relative h-3 w-full rounded-full bg-slate-100 overflow-hidden flex">
        <div className="w-[20%] h-full bg-amber-300" />
        <div className="w-[30%] h-full bg-emerald-400" />
        <div className="w-[20%] h-full bg-orange-400" />
        <div className="w-[30%] h-full bg-red-400" />
      </div>
      
      <div 
        className="relative -mt-4 w-1 h-5 bg-slate-800 rounded-full border-2 border-white shadow-sm transition-all duration-500 ease-out"
        style={{ left: `${percentage}%`, transform: 'translateX(-50%)' }}
      />
      
      <div className="flex justify-between text-xs text-slate-400 mt-2 font-mono">
        <span>14</span>
        <span>18.5</span>
        <span>24</span>
        <span>28</span>
        <span>32+</span>
      </div>
    </div>
  );
};
